import FilterEntityViewModel from '../../filterEntityViewModel';
import { PointSetType } from '@/domain/pointSet/PointSetType';
import { gettext } from '@/translations/gettext.setup';

const { $ngettext } = gettext;

export default class FilterMeasuredPointViewModel extends FilterEntityViewModel {

  _entityType;
  constructor(entity, locale, isPointLimitExceeded) {
    super(entity, locale);
    this._entityType = PointSetType;
    this._isPointLimitExceeded = isPointLimitExceeded;
  }

  get name() {
    const { totalCount } = this._entity;
    const defaultName = $ngettext('point', 'points', totalCount);
    return `${totalCount} ${defaultName}`;
  }

  get isResultSelectable() {
    return false;
  }

  get isResultWarning() {
    return this._isPointLimitExceeded;
  }

  get isResultVisible() {
    return true;
  }
}